import { useEffect, useState } from 'react';
import { Flex } from 'antd';
import logo from '../../assets/logos/white_logo.svg';
import './auth.css';
import CopyRight from './copyright';
import { useSelector } from 'react-redux';
import { selectCurrentTenant } from 'reducers/selectors';

const slides = [
  {
    heading: 'Your Personalized Portal',
    desc: 'Easily access your medical records, schedule consultations, and stay on top of your wellness plan with our secure and user-friendly patient portal.',
    height: '140px',
  },
  {
    heading: 'Stay Connected, Stay on Track',
    desc: 'Log in to schedule follow-ups, monitor your progress, and get expert support whenever you need it.',
    height: '140px',
  },
  {
    heading: 'Seamless Access to Your Wellness Journey',
    desc: 'Track your progress, consult with trusted healthcare professionals, and manage your prescription—all in one place.',
    height: '185px',
  },
];

const CarouselSlides = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { tenantData } = useSelector(selectCurrentTenant);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`carousel-slide`}>
      <div className={`carousel-slide-content`}>
        <Flex vertical justify="center" align="center" gap={48}>
          <Flex vertical justify="center" align="center" gap={50}>
            <img width={80} height={80} src={tenantData?.secondary_logo_url} alt="" />
            <div className="smooth-height" style={{ height: slides?.[currentSlide]?.height }}>
              {slides.map((slide, index) => (
                <Flex
                  key={index}
                  vertical
                  justify="center"
                  align="center"
                  gap={24}
                  style={{ position: 'absolute', left: 0, right: 0 }}
                >
                  <h1
                    className={`h2-medium text-align-center animated-text ${currentSlide === index ? 'fade-in' : 'fade-out'}`}
                  >
                    {slide.heading}
                  </h1>
                  <h5
                    className={`h5-medium text-align-center animated-text ${currentSlide === index ? 'fade-in' : 'fade-out'}`}
                  >
                    {slide.desc}
                  </h5>
                </Flex>
              ))}
            </div>
          </Flex>
          <div className="carousel-navigation">
            {slides.map((_, index) => (
              <div
                onClick={() => setCurrentSlide(index)}
                key={index}
                className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </Flex>
      </div>
    </div>
  );
};

export default function ({ children, center }) {
  return (
    <Flex className={'auth-page-body'}>
      <Flex vertical justify="center" align="center" style={{ padding: 0, position: 'relative' }} className="col-lg-6">
        <CarouselSlides />
      </Flex>
      <div className={`auth-box`}>
        <div className="no-scrollbar scroll-wrap">
          {children}
          <div className="hide-on-large">
            <CopyRight />
          </div>
        </div>
        <div className="hide-on-small">
          <CopyRight />
        </div>
      </div>
    </Flex>
  );
}
